import type { FC } from "react";
import { useEffect } from "react";

const CheckInOverlay: FC<{ name: string; onComplete: () => void }> = ({
  name,
  onComplete,
}) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2200);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-primaryDarkBlue">
      <div className="relative">
        <div className="bc-scale-in flex size-20 items-center justify-center rounded-full border-2 border-accentGreen/30 bg-accentGreen/10 sm:size-24">
          <svg
            className="size-10 text-accentGreen sm:size-12"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </div>
        <div
          className="absolute inset-0 rounded-full border-2 border-accentGreen/20"
          style={{ animation: "bc-pulse-ring 1.5s ease-out infinite" }}
        />
      </div>
      <p className="bc-fade-up bc-fade-up-1 mt-6 text-sm font-medium text-white/40">
        Welcome,
      </p>
      <h2 className="bc-fade-up bc-fade-up-2 mt-1 font-oswald text-3xl font-medium uppercase tracking-wide text-white sm:text-4xl">
        {name}
      </h2>
      <p className="bc-fade-up bc-fade-up-3 mt-3 text-sm text-white/25">
        You&apos;re all set
      </p>
    </div>
  );
};

export default CheckInOverlay;
